import React from "react";
import CV from '../assets/CV/CV-iñigo.pdf'
import './About.css'

const About = () => {



    return (
        <div className="container">
            <div>
                <div className="title-about">
                    <h1>About Me</h1>
                </div>
                <div className="text-about-container">
                    <p >
                        If you have come this far, then... you are welcome to my portfolio.
                    </p>

                    <p>
                        On this page you will find two options to view or download my cv/resume.First of all, I would like to tell you a little bit about my personal
                        experience.
                    </p>

                    <p>
                        So please, come with me!!!
                    </p>

                    <p>
                        My full name is Iñigo Malluguiza Castro and I currently live in the city of Alicante, Spain.Throughout my life, I had the opportunity to live in different cities and countries, such as Zaragoza, Madrid, Pamplona, Dublin or Marjayoun
                        (Lebanon), which allowed me to acquire experience dealing with different cultures and work environments.
                    </p>
                    <p>
                        A very important point are the human relationships;
                        I really trust in respect, active listening and empathy are key to provide the best environment posible. I strongly believe that passion drives excellence.A good attitude, initiative and high motivation are essential to change anything you want and accomplish any challenge.

                    </p>
                    <p>
                        I consider myself a responsible, loyal and restless person, always
                        interested in learning new things, one of my passions.
                    </p>
                    <p>
                        At the bottom of my heart, i strongly believe in attitude. A good attitude, initiative and high motivation are essential for change whatever you want in your life.
                    </p>
                    <p>
                        My other passion is sport, specially team sports. I have dedicated
                        thousand of hours in training, and it is still very important in my weekly
                        routine. I grew up practicing many different ones, such as skiing,
                        basketball, rugby, soccer, tennis, sailing... These taught me different
                        skills as teamwork, honesty, active listening, perseverance,
                        adaptability, leadership, conflict resolution, motivation, humility and
                        verbal and visual communication. I love teamwork and I am always
                        available to help the team whenever I can.
                    </p>
                    <p >
                        Last but not least, I would like to thank you for your time and looking
                        forward to hearing from you!
                    </p>
                    <p>
                        Best Regards...!
                    </p>
                    <p>
                        Iñigo
                    </p>
                </div>
            </div>

            <div class="frame">

                <a class="custom-btn btn-1" href='https://drive.google.com/file/d/1tFJxWRKwpJNb9sF5gKdTE2pbOXrBF81K/view?usp=sharing'>View CV</a>

                <a class="custom-btn btn-1" href={CV} download disable>Download CV</a>
            </div>
        </div>
    );
};

export default About;